module.exports = __webpack_public_path__ + "img/as.9a56ee4e.jpg";